import { Injectable } from '@angular/core';
import * as _ from 'underscore';

@Injectable({
  providedIn: 'root'
})
export class HelperService {

  constructor() { }


  public each(array, delegate) {
    return _.each(array, delegate);
  }

  public where(array, search){
    return _.where(array, search);
  }

  public filter(array,propiedades){
    return _.filter(array, propiedades);
  }

  public find(array, propiedades){
    return _.find(array, propiedades);
  }

  public findIndex(array, propiedades){
    return _.findIndex(array, propiedades);
  }

  public sortBy(array, propiedades){
    return _.sortBy(array, propiedades);
  }

  public findKey(object, propiedades){
    return _.findKey(object, propiedades);
  }

}
